import listRouter from "./list/router";
import settingRouter from "./setting/router";

export default [...listRouter, ...settingRouter];
